export default __webpack_public_path__ + "static/media/rain-active.7d89d19a.svg";